<template>

  <div>
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Settings</li>
      </ol>
    </div>
    <div class="main-box two-column">
      <!--      sidebar setting start-->
      <sidebar></sidebar>
      <!--      sidebar setting end-->
      <div class="setting-info-wrp">
        <!-- location -->
        <div class="loacatoin-box">
          <div class="row align-items-center">
            <div class="col-6">
              <h1>Work Shifts</h1>
            </div>
            <div class="col-6 text-right">
              <button type="button" class="btn btn-primary" data-toggle="modal" @click="openForm"><span
                class="fa fa-plus"></span> Add Shift
              </button>
            </div>
          </div>

          <div class="row">
            <div class="col-lg-12 p-20">
              <table class="table">
                <thead class="table-head">
                <tr>
                  <th scope="col">Title</th>
                  <th scope="col">Start Time</th>
                  <th scope="col">End Time</th>
                  <th scope="col" width="15%" class="text-center">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr
                  v-for="(workShift, index) of workShifts"
                  :key="index"
                >
                  <td>
                   <span class="text-capitalize"> {{ workShift.title }}</span>
                  </td>
                  <td>
                    {{ workShift.start_time }}
                  </td>
                  <td>
                    {{ workShift.end_time }}
                  </td>

                  <td class="text-center">
                    <a
                      href="javascript:void(0)"
                      class="edit-icon flex-shrink-0 pl-2"
                      @click="workShiftEdit(workShift.id)"
                    ><i class="ico-pencil"></i
                    ></a>
                    &nbsp;&nbsp;&nbsp;<a
                    href="javascript:void(0)" class="text-danger"
                    @click="workShiftDelete(workShift.id)"
                  ><i class="ico ico-delete"></i
                  ></a>
                  </td>
                </tr>
                <tr v-if="!workShifts.length">
                  <td colspan="4" class="text-center text-page">No data found.</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="row align-items-center">
            <div class="col-6">
              <h1>Quarter Work Shifts</h1>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 p-20">
              <table class="table">
                <thead class="table-head">
                <tr>
                  <th scope="col">Quarter Type</th>
                  <th scope="col">Quarter Time</th>
                  <th scope="col" width="15%" class="text-center">Action</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(quarterWorkShift, index) of quarterWorkShifts" :key="index">
                  <td>
                    <span class="text-capitalize"> {{ quarterWorkShift.type }}</span>
                  </td>
                  <td>
                    {{ quarterWorkShift.time }}
                  </td>
                  <td class="text-center">
                    <a
                      href="javascript:void(0)"
                      class="edit-icon flex-shrink-0 pl-2"
                      @click="quarterWorkShiftEdit(quarterWorkShift.id)"
                    ><i class="ico-pencil"></i
                    ></a>
                  </td>
                </tr>
                <tr v-if="!quarterWorkShifts.length">
                  <td colspan="4" class="text-center text-page">No data found.</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" tabindex="-1" role="dialog" id="shiftModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ modalTitle }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-12">
                <label >Title</label>
                <div class="form-group">
                  <input type="text" placeholder="Title" v-model="form.title" class="form-control">
                </div>
              </div>
              <div class="col-lg-6">
                <label >Start Time</label>
                <div class="form-group">
                  <input type="time" placeholder="Start Time" v-model="form.start_time" class="form-control">
                </div>
              </div>
              <div class="col-lg-6">
                <label >End Time</label>
                <div class="form-group">
                  <input type="time" placeholder="End Time" v-model="form.end_time" class="form-control">
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" @click="store" class="btn btn-primary">Save</button>
            <button type="button" @click="resetForm" class="btn btn-secondary" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" tabindex="-1" role="dialog" id="quarterShiftModal">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Quarter Shift Modal</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-12">
                <label >Type</label>
                <div class="form-group">
                  <input type="text" readonly placeholder="Title" v-model="quarterForm.type" class="form-control">
                </div>
              </div>
              <div class="col-lg-12">
                <label > Time</label>
                <div class="form-group">
                  <input type="text" placeholder=" Time" v-model="quarterForm.time" class="form-control">
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" @click="quarterStore" class="btn btn-primary">Save</button>
            <button type="button" @click="quarterResetForm" class="btn btn-secondary" data-dismiss="modal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import sidebar from "./sidebar";
import Swal from "sweetalert2";

export default {
  components: {
    sidebar,
    Swal
  },
  props: [],
  data() {
    return {
      form: {
        id: null,
        title: '',
        start_time: '',
        end_time: ''
      },
      quarterForm: {
        id: null,
        type: '',
        time: '',
      },
      isQuarterEdit: false,
      modalTitle: 'Add Shift',
      company_id: this.$store.getters.getSelectedCompany.id,
      workShifts: [],
      quarterWorkShifts: [],
    }
  },
  serverPrefetch() {
  },
  created() {
    this.getCompanyWorkShifts();
    this.getCompanyQuarterWorkShifts();
  },
  mounted() {
  },
  methods: {
    store() {
      let url = this.$WorkShift;
      let method = 'post';
      let message = "Created successfully";

      if(this.isEdit){
        url = this.$WorkShift+'/'+this.form.id;
        method = 'patch';
        message = "Updated successfully";
      }

      this.$axios({
        method: method,
        data: {
          title: this.form.title,
          start_time: this.form.start_time,
          end_time: this.form.end_time,
          company_id: this.company_id,
        },
        url: url,
        headers: this.getAuthHeader()
      }).then((res) => {
          if (res.data.status === 200) {
            $root.$toast.success(message);
            this.resetForm();
            this.getCompanyWorkShifts();
          }
        });
    },
    workShiftEdit(id) {
      axios.get(this.$WorkShift + '/' + id, {
        headers: this.getAuthHeader(),
        params: {
          company_id: this.company_id,
        }
      })
        .then(res => {
          if (res.data.status === 200) {
            this.isEdit = true;
            this.form = res.data.result;
            $('#shiftModal').modal('show');
          }
        });
    },
    quarterStore() {
      let url = this.$QuarterWorkShifts;
      let method = 'post';
      let message = "Created successfully";

      if(this.isQuarterEdit){
        url = this.$QuarterWorkShifts+'/update/'+this.quarterForm.id;
        message = "Updated successfully";
      }

      this.$axios({
        method: method,
        data: {
          time: this.quarterForm.time,
          company_id: this.company_id,
        },
        url: url,
        headers: this.getAuthHeader()
      }).then((res) => {
        if (res.data.status === 200) {
          $root.$toast.success(message);
          this.quarterResetForm();
          this.getCompanyQuarterWorkShifts();
        }
      });
    },
    quarterWorkShiftEdit(id) {
      axios.get(this.$QuarterWorkShifts + '/' + id, {
        headers: this.getAuthHeader(),
        params: {
          company_id: this.company_id,
        }
      })
        .then(res => {
          if (res.data.status === 200) {
            this.isQuarterEdit = true;
            this.quarterForm = res.data.result;
            $('#quarterShiftModal').modal('show');
          }
        });
    },
    workShiftDelete(id) {
      new Swal({
        title: "Delete Shift?",
        icon: "warning",
        text: "Are you sure? You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!"
      }).then((result) => {
        if (result.value) {
          axios.delete(this.$WorkShift + '/' + id, {
            headers: this.getAuthHeader(),
            params: {
              company_id: this.company_id,
            }
          })
            .then(res => {
              if (res.data.status === 200) {
                this.form = {};
                this.getCompanyWorkShifts();
                $root.$toast.error('Deleted successfully.');
              }
            });
        }
      });
    },
    getCompanyWorkShifts() {
      axios.get(this.$WorkShift, {
        headers: this.getAuthHeader(),
        params: {
          company_id: this.company_id,
        }
      })
        .then(res => {
          if (res.data.status === 200) {
            this.workShifts = res.data.result;

          }
        });
    },
    getCompanyQuarterWorkShifts() {
      axios.get(this.$QuarterWorkShifts, {
        headers: this.getAuthHeader(),
        params: {
          company_id: this.company_id,
        }
      })
        .then(res => {
          if (res.data.status === 200) {
            this.quarterWorkShifts = res.data.result;
          }
        });
    },
    quarterResetForm() {
      this.quarterForm = {};
      $('#quarterShiftModal').modal('hide');
      this.isQuarterEdit = false;
    },
    resetForm() {
      this.form = {};
      $('#shiftModal').modal('hide');
      this.isEdit = false;
    },

    openForm() {
      this.isEdit = false;
      this.form = {};
      $('#shiftModal').modal('show');
    }
  }
}
</script>
<style scoped>
.table tr {
  border: none !important;
}

.table thead {
  background-color: #E9E9E9 !important;
}

.table thead th {
  border: none !important;
}

.table-striped > tbody > tr:nth-child(odd) > td,
.table-striped > tbody > tr:nth-child(odd) > th {
  background-color: #F7F7F7;
}

body {
  font-family: "Lato", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
}
</style>
